import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'
import { CELL_SIZE, GAP } from './grid'

export enum PosTableShapeId {
  SQUARE = 1,
  CIRCLE = 2,
  RECTANGLE_VERTICAL = 3,
  RECTANGLE_HORIZONTAL = 4,
}

export class PosTableShape extends Codebook<PosTableShapeId> {
  static readonly SQUARE = new PosTableShape(PosTableShapeId.SQUARE, () => $t('Square'), 2, 2)
  static readonly CIRCLE = new PosTableShape(PosTableShapeId.CIRCLE, () => $t('Circle'), 2, 2)
  static readonly RECTANGLE_VERTICAL = new PosTableShape(
    PosTableShapeId.RECTANGLE_VERTICAL,
    () => $t('Vertical rectangle'),
    2,
    4,
  )
  static readonly RECTANGLE_HORIZONTAL = new PosTableShape(
    PosTableShapeId.RECTANGLE_HORIZONTAL,
    () => $t('Horizontal rectangle'),
    4,
    2,
  )

  private constructor(
    public readonly id: PosTableShapeId,
    public readonly name: () => string,
    /** Footprint in grid cells, mirrors Shape::gridWidth()/gridHeight() on the BE. */
    public readonly gridWidth: number,
    public readonly gridHeight: number,
  ) {
    super(id)
  }

  /** Rendered width in px: spans the footprint's cells minus the surrounding gap. */
  get width(): number {
    return this.gridWidth * CELL_SIZE - GAP
  }

  /** Rendered height in px: spans the footprint's cells minus the surrounding gap. */
  get height(): number {
    return this.gridHeight * CELL_SIZE - GAP
  }

  get isCircle(): boolean {
    return this.id === PosTableShapeId.CIRCLE
  }
}
